module.exports = __webpack_public_path__ + "static/media/Icn-xhtml.1ab86d66.svg";